export default "__VITE_ASSET__BB1eSidi__"